import app from './lib/pico-init';
import { initReactComponents } from './react.jsx';

initReactComponents();

app.mount();

import { BodyOverlay } from './components/web-components/body-overlay';
import { CollectionProgressBar } from './components/web-components/collection-progress-bar';
import { SaveButton } from './components/web-components/save-button';
import { SaveCount } from './components/web-components/save-count';
import { SavedItems } from './components/web-components/saved-items';
import { SideDrawer } from './components/web-components/side-drawer';
import { SideDrawerBtn } from './components/web-components/side-drawer-btn';
export {
	BodyOverlay,
	CollectionProgressBar,
	SaveButton,
	SaveCount,
	SavedItems,
	SideDrawer,
	SideDrawerBtn,
};
